// Module
var code = "<a wcag-ignore>{{ richDropdown.item.needsTranslated ? (richDropdown.item[richDropdown.options.selectedTitleKey || richDropdown.options.titleKey || 'title'] | translate) : richDropdown.item[richDropdown.options.selectedTitleKey || richDropdown.options.titleKey || 'title'] }}</a>";
// Exports
module.exports = code;